module.exports = __webpack_public_path__ + "img/mcash.9ab119d8.png";